import React from 'react';
import { AxisInterface } from '../../../graphinterfaces/AxisInterface';

export const AxisContainer = () => {
  return (
    <div id="AxisContainer">
      <AxisInterface />
    </div>
  );
};